// extracted by mini-css-extract-plugin
export default {"root":"TimeSetter_root__i0a88","flexColumn":"TimeSetter_flexColumn__TeMak","timeDiv":"TimeSetter_timeDiv__zJ0z8","timeBtn":"TimeSetter_timeBtn__FSJg-"};